exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse[data-v-148c6310] {\n.collapse-trigger {\n    display: inline;\n    cursor: pointer;\n}\n.collapse-content {\n    display: inherit;\n}\n}\n", ""]);

// exports
